import React, {useEffect } from "react"
import { PageName } from "ui/PageName"
import { Form, Flex } from "antd"
import { useParams } from "react-router-dom"
import { useDispatch,useSelector } from "react-redux"
import {getQuestionnaireTemplateById} from "store/question"
import FirstLoading from "modules/loader-watchers/FirstLoading"
import CustomQuestions from "./CustomQuestions"
export const TemplateDetails = () => {
  const {id}=useParams()
  const dispatch=useDispatch()
  const templateDetail=useSelector((state)=>state.question.currentTemplate.data)
  const loading=useSelector((state)=>state.question.currentTemplate.loading)
  const templateQuestions=useSelector((state)=>state.question.templateQuestions.data)
  useEffect(()=>{
    dispatch(getQuestionnaireTemplateById(id))
  },[id])
  const [form] = Form.useForm()
  const handleOk = () => {
    form.validateFields().then((values) => {

      //   onSave?.(values)
      form.resetFields()
    })
  }
  return (
    <FirstLoading loading={loading}>
      <PageName title={templateDetail?.name} />
      <Form layout="vertical" form={form} preserve={false} onFinish={handleOk} style={{ marginTop: 16 }}>
        <Flex align="center" justify="space-between">
        </Flex>
        <CustomQuestions templateId={id} templateQuestions={templateQuestions} />
      </Form>
    </FirstLoading>
  )
}
